import ujs from '@rails/ujs';
ujs.start();

import './checkbox_trigger';
